import { Component, Input } from '@angular/core';

import { MonthStatusEnum } from '../../../enums';
import { IMonthlyEventData } from '../../../interfaces';

@Component({
    selector: 'app-disable-month-modal',
    templateUrl: './disable-month-modal.component.html',
    styleUrls: ['./disable-month-modal.component.scss'],
})
export class DisableMonthModalComponent {
    @Input() public selectedMonth: IMonthlyEventData;
    @Input() public selectedMonthName: string;

    public monthEventsStatusEnum = MonthStatusEnum;
}
